import { render, staticRenderFns } from "./OfficialsPgHeader.vue?vue&type=template&id=1a4196e6&scoped=true&"
import script from "./OfficialsPgHeader.vue?vue&type=script&lang=js&"
export * from "./OfficialsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./OfficialsPgHeader.vue?vue&type=style&index=0&id=1a4196e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4196e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
